// Google consent mode v2 defaults: denied for the EEA, UK and Switzerland until Google's certified consent
// message (AdSense "Privacy & messaging") updates them. Elsewhere nothing is denied. DevStackKit shows no
// consent banner of its own. Must run before Firebase Analytics / gtag.js loads so the command is first in the queue.

export const CONSENT_REGIONS = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU',
  'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'GB', 'CH',
];

export function consentDefaultCommand(): ['consent', 'default', Record<string, unknown>] {
  return [
    'consent',
    'default',
    {
      ad_storage: 'denied',
      analytics_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      region: CONSENT_REGIONS,
      wait_for_update: 500,
    },
  ];
}

type GtagWindow = Window & { dataLayer?: unknown[] };

let applied = false;

export function applyConsentDefaults(win: GtagWindow = window): void {
  if (applied) return;
  applied = true;
  try {
    win.dataLayer = win.dataLayer || [];
    // gtag.js reads `arguments` objects from the data layer, not arrays.
    (function gtag(..._args: unknown[]) {
      // eslint-disable-next-line prefer-rest-params
      win.dataLayer!.push(arguments);
    })(...consentDefaultCommand());
  } catch {
    // Consent defaults are best effort; analytics and ads still wait for Google's own message.
  }
}

/** Test helper. */
export function resetConsentForTests(): void {
  applied = false;
}
